import React from 'react';
import { Breadcrumb } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Link, useLocation } from 'react-router-dom';

const skipBreadcrumb = '#';

const breadcrumbPaths: Record<string, string> = {
	'/upload': 'Upload',
	'/super-pea': 'PEA Aggregator',
	'/reporting': 'Reports',
	'/settings': 'Settings',
	'/settings/plan': 'Plan',
	'/users': 'Manage users',
	'/reporting/rula': 'RULA',
	'/reporting/reba': 'REBA',
	'/reporting/niosh': 'NIOSH',
	'/action-plans': 'Action plans',
	'/settings/account': 'My account',
	'/settings/companies': 'Companies',
	'/settings/preferences': 'Preferences',
	'/settings/information': 'Information',
	'/settings/integrations': 'Integrations',
	'/reporting/strain-index': 'Strain Index',
	'/reporting/list/strain-index': 'Strain Index',
	'/super-pea/new-document': 'New document',
	'/reporting/kim-pp': 'KIM - Push and pull',
	'/settings/integrations/azure-ad': 'Azure AD',
	'/reporting/liberty-mutual': 'Liberty Mutual',
	'/settings/integrations/azure-ad/group': 'Grupo',
	'/reporting/kim-mho': 'Manual Handling Operations',
	'/reporting/list/kim-mho': 'Manual Handling Operations',
	'/reporting/personalised-report': 'Personalised report',
	'/settings/personalised-reports': 'Personalised reports',
	'/settings/personalised-reports/manage': 'Manage report',
	'/preliminary-ergonomic-analysis': 'Ergonomic Workplace Analysis',
	'/reporting/preliminary-ergonomic-analysis': 'Ergonomic Workplace Analysis',
	'/reporting/list': skipBreadcrumb,
	'/reporting/list/personalised-report': skipBreadcrumb,
	'/reporting/list/personalised-report/*': 'Personalised reports',
	'/reporting/list/angle-time': 'Angle by time',
	'/reporting/angle-time': 'Angle by time',
	'/reporting/list/score-parts': 'RULA',
	'/reporting/list/kim-pp': 'KIM - Push and Pull',
	'/reporting/list/liberty-mutual': 'Liberty Mutual',
	'/reporting/list/preliminary-ergonomic-analysis': 'Preliminary Ergonomic Analyses',
	'/reporting/list/ansi-z': 'ANSI-Z-365',
	'/rotation': 'Rotation',
	'/rotation/report': 'Report',
	'/ergonomic-work-analysis': 'EWA'
};

export function WrapperBreadcrumb() {
	const location = useLocation();
	const pathnames = location.pathname.split('/').filter((i) => i);

	const breadcrumbs: JSX.Element[] = pathnames
		.map((key, index) => {
			let url = `/${pathnames.slice(0, index + 1).join('/')}`;
			let label = key.charAt(0).toUpperCase() + key.slice(1);

			if (breadcrumbPaths[url] === skipBreadcrumb) {
				return null;
			}

			if (breadcrumbPaths[url]) label = breadcrumbPaths[url];

			if (pathnames.length === index + 1) {
				const exactly_path = breadcrumbPaths[url];
				const generic_path = breadcrumbPaths[url.replace(key, '*')];
				label = exactly_path || generic_path || label;
			}

			return (
				<Breadcrumb.Item key={key}>
					<Link to={url}>{I18n.get(label)}</Link>
				</Breadcrumb.Item>
			);
		})
		.filter(Boolean) as JSX.Element[];

	const items: JSX.Element[] = [
		<Breadcrumb.Item key="home">
			<Link to="/">{I18n.get('Home')}</Link>
		</Breadcrumb.Item>
	].concat(breadcrumbs);

	return <Breadcrumb>{items}</Breadcrumb>;
}
